import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import { OrderLogResponse } from '@models/order/orderLog';
import { useFlow } from '@router/stackflow';
import { useTranslation } from 'react-i18next';

import useOrderCancelable from './hooks/useOrderCancelable';
import useReOrder from './hooks/useReOrder';
import styles from './styles.module.scss';

interface Props {
    orderLog: OrderLogResponse;
}

function OrderFooter({ orderLog }:Props) {
    const { t } = useTranslation('orderLog');
    const { orderNo } = orderLog;
    const { reOrder, reOrderEnabled } = useReOrder(orderLog);
    const cancelable = useOrderCancelable(orderLog);
    const { push } = useFlow();
    return (
        <Column fullWidth spacing={20}>
            <Row spacing={12} fullWidth>
                {cancelable && (
                    <Button variant='tertiary'
                        className={styles.button}
                        onClick={() => push('CancelOrderModal', { orderNo })} >
                        {t('footer.cancel')}
                    </Button>
                )}
                <Button className={styles.button}
                    disabled={!reOrderEnabled}
                    onClick={reOrder} >
                    {t('footer.reorder')}
                </Button>
            </Row>
        </Column>
    );
}

export default OrderFooter;
